const muiAppBarTheme = (theme) => {
  theme.overrides.MuiAppBar = {
    colorPrimary: {
      backgroundColor: '#FFF',
      color: '#000',
    },
  };
};

export default muiAppBarTheme;
